import { Box, Typography } from '@mui/material';
import React from 'react';
import ExcelImportTab from '../Interface/ExcelImportTab';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';
import useUsers from '../../context/UsersContext';
import { sxConfig } from './masterDataImport.style';

const ImportCard = ({ item }) => {
  const { user } = useUsers();
  const { title, templateFn, importFn } = item;

  const handleTemplate = () => {
    templateFn().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleImport = (files) => {
    importFn(files, user.userId).then(() => {
      addNotification({
        content: 'Az import sikeres!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  return (
    <Box sx={sxConfig.cardContainer}>
      <Typography sx={sxConfig.cardTypography}>{title}</Typography>
      <ExcelImportTab handleTemplate={handleTemplate} handleImport={handleImport} />
    </Box>
  );
};

export default ImportCard;
